import { render } from "./index.vue?vue&type=template&id=a4bc464a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a4bc464a&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bc464a"]])

export default __exports__